/* eslint-disable import/prefer-default-export */
import { RECEIVE_PROCESS_VIEW, REQUEST_PROCESS_VIEW, PROCESS_VIEW_ERROR } from '../actions/activeStateActions';
import { RECEIVE_OBJECT_VIEW } from '../actions/activeObjectActions';
import { RECEIVE_LOGOUT_USER } from '../actions/activeUserActions';

const initialActiveStateState = {
	isFetching: false,
	state: {
		connectionObjects: [],
		connections: [],
		name: '',
		_id: '',
		key: '',
		successors: [],
		predecessors: [],
		parents: [],
		parts: [],
	},
	error: null,
};

export const activeStateReducer = (state = initialActiveStateState, action) => {
	switch (action.type) {
		case REQUEST_PROCESS_VIEW:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_PROCESS_VIEW:
			// sets new state and fetching ended
			return { ...state, state: action.payload, isFetching: false };
		case PROCESS_VIEW_ERROR:
			// fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case RECEIVE_LOGOUT_USER:
			// sets new state and fetching ended
			return { ...initialActiveStateState, isFetching: false };
		case RECEIVE_OBJECT_VIEW:
			// sets new state and fetching ended
			return { ...state, error: null };

		default:
			return state;
	}
};
